import { render, staticRenderFns } from "./MemoryCurve.vue?vue&type=template&id=38e4fdfa&scoped=true"
import script from "./MemoryCurve.vue?vue&type=script&lang=js"
export * from "./MemoryCurve.vue?vue&type=script&lang=js"
import style0 from "./MemoryCurve.vue?vue&type=style&index=0&id=38e4fdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4fdfa",
  null
  
)

export default component.exports